// extracted by mini-css-extract-plugin
var _1 = "utn4G";
export { _1 as "warningMessage" }
